"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRouter = createRouter;
Object.defineProperty(exports, "createBrowserHistory", {
  enumerable: true,
  get: function get() {
    return _createBrowserHistory.default;
  }
});
Object.defineProperty(exports, "createHashHistory", {
  enumerable: true,
  get: function get() {
    return _createHashHistory.default;
  }
});
Object.defineProperty(exports, "createMemoryHistory", {
  enumerable: true,
  get: function get() {
    return _createMemoryHistory.default;
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _Facade.Link;
  }
});
Object.defineProperty(exports, "Request", {
  enumerable: true,
  get: function get() {
    return _Facade.Request;
  }
});
Object.defineProperty(exports, "URL", {
  enumerable: true,
  get: function get() {
    return _Facade.URL;
  }
});

var _createBrowserHistory = _interopRequireDefault(require("history/createBrowserHistory"));

var _createHashHistory = _interopRequireDefault(require("history/createHashHistory"));

var _createMemoryHistory = _interopRequireDefault(require("history/createMemoryHistory"));

var _Facade = require("./Facade");

var _Router = _interopRequireDefault(require("./Router"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRouter() {
  var history = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _createHashHistory.default)();
  return new _Router.default(_Facade.connector.newInitializedInstance(history));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9saWIvaW5kZXguanMiXSwibmFtZXMiOlsiY3JlYXRlUm91dGVyIiwiaGlzdG9yeSIsIlJvdXRlciIsImNvbm5lY3RvciIsIm5ld0luaXRpYWxpemVkSW5zdGFuY2UiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFDQTs7QUFDQTs7OztBQUVBLFNBQVNBLFlBQVQsR0FBcUQ7QUFBQSxNQUEvQkMsT0FBK0IsdUVBQXJCLGlDQUFxQjtBQUNuRCxTQUFPLElBQUlDLGVBQUosQ0FBV0Msa0JBQVVDLHNCQUFWLENBQWlDSCxPQUFqQyxDQUFYLENBQVA7QUFDRCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBjcmVhdGVCcm93c2VySGlzdG9yeSBmcm9tIFwiaGlzdG9yeS9jcmVhdGVCcm93c2VySGlzdG9yeVwiO1xuaW1wb3J0IGNyZWF0ZUhhc2hIaXN0b3J5IGZyb20gXCJoaXN0b3J5L2NyZWF0ZUhhc2hIaXN0b3J5XCI7XG5pbXBvcnQgY3JlYXRlTWVtb3J5SGlzdG9yeSBmcm9tIFwiaGlzdG9yeS9jcmVhdGVNZW1vcnlIaXN0b3J5XCI7XG5pbXBvcnQgeyBMaW5rLCBSZXF1ZXN0LCBVUkwsIGNvbm5lY3RvciB9IGZyb20gXCIuL0ZhY2FkZVwiO1xuaW1wb3J0IFJvdXRlciBmcm9tIFwiLi9Sb3V0ZXJcIjtcblxuZnVuY3Rpb24gY3JlYXRlUm91dGVyKGhpc3RvcnkgPSBjcmVhdGVIYXNoSGlzdG9yeSgpKSB7XG4gIHJldHVybiBuZXcgUm91dGVyKGNvbm5lY3Rvci5uZXdJbml0aWFsaXplZEluc3RhbmNlKGhpc3RvcnkpKTtcbn1cblxuZXhwb3J0IHtcbiAgY3JlYXRlUm91dGVyLFxuICBjcmVhdGVCcm93c2VySGlzdG9yeSxcbiAgY3JlYXRlSGFzaEhpc3RvcnksXG4gIGNyZWF0ZU1lbW9yeUhpc3RvcnksXG4gIExpbmssXG4gIFJlcXVlc3QsXG4gIFVSTFxufTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/index.js
// module id = 122
// module chunks = 0